<template>
    <div>
        <item-header-row>
            <b-col cols="10" md="8" class="item-header">
                {{ $t('common.products') }}
            </b-col>
            <b-col cols="2" md="4" class="item-header flex-align-right">
                {{ $t('common.quantity') }}
            </b-col>
        </item-header-row>
        <b-form-checkbox-group
            v-model="formData.itemsSelected"
            class="order-items"
        >
            <div v-for="item in orderData.items.filter(itemFilter)"
                 :key="item.orderItemId">
                <b-row :class="itemClasses(formData.itemsSelected, item.sku)">
                    <b-col cols="10" md="8"
                           class="item-combo-box"
                           @click="select(formData.itemsSelected, item.sku)">
                        <b-form-checkbox
                            style="pointer-events: none"
                            :value="item.sku"
                        ></b-form-checkbox>

                        <item-image :src="item.imageUrl" :alt="item.name"></item-image>

                        <div class="flex flex-column">
                            <span>{{ item.name }}</span><br>
                            <span class="prod-det">{{ $t('common.listItemSku', item) }}</span>

                            <div v-if="item.validationErrors.length">
                                <div v-for="(error, eIndex) in item.validationErrors" :key="'e-' + eIndex">
                                    <span class="item-error-text">{{ error }}</span><br>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="2" md="4" class="flex-align-right">
                        <span v-if="item.alreadyReturnedQuantity === 0" class="item-qty">{{ $t('common.pcs', item) }}</span>
                        <div v-else>
                            <span class="item-qty item-qty">{{ $t('common.pcs', { quantity: allowedQuantity(item) }) }}</span>
                            <span class="item-qty item-qty-strike">{{ $t('common.pcs', { quantity: item.quantity }) }}</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="isSelected(formData.itemsSelected, item.sku)" class="mt-2">
                    <transition name="fade">
                        <b-col offset-md="2">
                            <b-row>
                                <b-col cols="8">
                                    <b-form-group :label="$t('step2.reasonTitle')">
                                        <b-form-select v-model="item.returnReasonType"
                                                       :options="reasonOptions">
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group :label="$t('common.quantity')" style="text-align: right;">
                                        <div class="item-qty-wrapper">
                                            <b-form-input
                                                type="number"
                                                :state="validateQuantity(item)"
                                                min="0"
                                                :max="allowedQuantity(item)"
                                                :value="item.selectedQuantity ? item.selectedQuantity : 0"
                                                @input="ensureMaxQuantity(item, $event);"
                                                class="item-qty-input"
                                            ></b-form-input>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-form-group :label="$t('step2.reason.comment')">
                                <b-form-textarea v-model="item.comment"></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </transition>
                </b-row>
            </div>
        </b-form-checkbox-group>
    </div>
</template>
<script>
import ItemImage from "./Item/ItemImage";
import ItemHeaderRow from "./Item/ItemHeaderRow";

export default {
    name: 'ItemList',
    components: {
        ItemImage,
        ItemHeaderRow
    },
    props: {
        formData: {},
        orderData: {},
        reasonOptions: [],
        isReturnCase: {
            type: Boolean
        }
    },
    methods: {
        allowedQuantity(item) {
            return item.deliveredQuantity - item.alreadyReturnedQuantity;
        },
        validateQuantity(item) {
            return parseInt(item.selectedQuantity, 10) > 0
                && parseInt(item.selectedQuantity, 10) <= parseInt(this.allowedQuantity(item), 10);
        },
        ensureMaxQuantity: function (item, event) {
            if (event > this.allowedQuantity(item)) {
                item.selectedQuantity = this.allowedQuantity(item);
            } else {
                item.selectedQuantity = event;
            }
            item.validQuantity = this.validateQuantity(item);
            this.$emit('update', this.orderData);
        },
        isSelected(items, sku) {
            return items.includes(sku);
        },
        select(items, sku) {
            if (items.includes(sku)) {
                const index = items.indexOf(sku);
                if (index > -1) {
                    items.splice(index, 1);
                }
                return;
            }

            let item = this.getItemBySku(sku);
            item.selectedQuantity = item.selectedQuantity ? item.selectedQuantity : 0;
            items.push(sku);
        },
        getItemBySku(sku) {
            return this.orderData.items.find(item => item.sku === sku);
        },
        itemFilter(item) {
            return !(item.sku >= 9950 && item.sku <= 9999);
        },
        itemClasses(items, sku) {
            const item = this.getItemBySku(sku);

            let classes = [
                'prod-list',
                'd-flex',
                'align-items-center',
                'py-2'
            ];

            if (sku >= 9950 && sku <= 9999) {
                classes.push('item-hidden');
            }

            if (this.isReturnCase) {
                if (item.canBeReturned === false) {
                    classes.push('item-blocked');
                }
            }

            if (items.includes(sku)) {
                classes.push('active');
            }

            if (item.validationErrors.length) {
                classes.push('has-errors');
            }

            return classes.join(' ');
        }
    }
}
</script>
<style scoped>

.prod-list {
    cursor: pointer;
}

.prod-list.active {
    background: #e8e8e8;
}

.order-items {
    margin-bottom: 24px;
}

.item-combo-box {
    display: grid;
    grid-template-columns: 40px 70px 1fr;
    align-items: center;
}

.item-qty-strike {
    text-decoration: line-through;
}

.has-errors {
    border-radius: 3px;
    border: 1px solid #ff7979;
}

.item-blocked {
    opacity: 0.5;
    pointer-events: none;
}

.item-large {
    opacity: 0.5;
    pointer-events: none;
}

.item-error-text {
    color: #a91515;
    font-size: 12px;
}

.item-qty-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.item-qty {
    display: inline-flex;
    margin-right: 0.5rem;
}

.item-qty-input {
    width: 100px;
    margin-left: auto;
}

.flex-align-right {
    display: flex;
    justify-content: flex-end;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
